import _ from 'underscore';

export const WizardBlockingType = {
  Animation: 'Animation',
  Blocker: 'Blocker',
};

export const SUB_ADS_WIZARD_STEP_PATHS = {
  websiteSelection: 'websiteSelection',
  smartPageSignupOption: 'smartPageSignupOption',
  smartPageEditor: 'smartPageEditor',
  advertisingPlan: 'advertisingPlan',
  payment: 'payment',
};

// These values are used by postABTestingEventLog
export const SUB_ADS_STEP_TO_PAGE = {
  websiteSelection: 'subads010.websiteSelection',
  smartPageSignupOption: 'subads020.smartPageSignupOption',
  smartPageEditor: 'subads030.smartPageEditor',
  advertisingPlan: 'subads040.advertisingPlan',
  payment: 'subads050.payment',
};

export const getHasSmartPageSteps = stepList => (
  _.contains(stepList, SUB_ADS_WIZARD_STEP_PATHS.smartPageSignupOption)
  && _.contains(stepList, SUB_ADS_WIZARD_STEP_PATHS.smartPageEditor)
);
